import './App.css';
import React from "react";
import code from "./images/code.png"
import logo from "./images/logo.png"
import stats from "./images/icon_stats.png"
import {store} from "./store";
import {getCompany, getLocation, getScans, getRank, getDaily, getMonthlyBaseline} from "./apiCaller";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {DeviceInterface} from "./androidInterface"


function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


function TestError() {
    const a = null;
    return a.hello();
}

class App extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            deviceToken: "",
            company: {baseline: Number(getCookie("baseline"))},
            location: {
                ID: 0
            },
            count: 0,
            rank: 0,
            showStats: false,
            stats: [{name: 'Loading',
                scans: 0}],
            statsBarOffset: 0,
            host: store.getState().host,
            logoToken: "noToken",
            monthlyBaselineData: [{name: 'Loading',
                scans: 0, baseline: 0}],
            isOnline: navigator.onLine
        }


    }



    componentDidMount = async () => {

        this.startupTouchEvents()

        //let viewportHeight = window.innerHeight;
        //document.getElementById("height").innerText = viewportHeight

        if (document.getElementById("devtoken") == undefined){
            fetch("/api/config/getToken")
                .then((response) => response.text())
                .then((token) => {
                    var element = document.createElement("input")
                    element.type = "hidden"
                    element.value = token
                    element.id = "devtoken"
                    document.body.appendChild(element)

                    store.dispatch({"type": "devToken", "payload": token})
                })


        }


        window.addEventListener('error', (event) => {
            console.warn("error")
            //this.props.rollbar.error('Console Error', event);
        }, true); // The `true` argument enables capture phase for catching errors early
        window.addEventListener("unhandledrejection", function (event) {
            console.warn("error")
            //this.props.rollbar.error('Console Error', event);
        });
        const img = document.querySelector('img');
        img.addEventListener('error', (event) => {
            console.warn("error")
            //this.props.rollbar.error('Console Error', event);
        });

        console.log(console.log('navigator.onLine:', navigator.onLine))
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);

        store.subscribe(() => {


            var newScans = store.getState().scans

            console.log(newScans)

            if(newScans !== this.state.count){
                document.cookie = `scans=${newScans}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                this.setState({count: newScans})
                getDaily((response) =>{
                    console.log(response)
                    var data = []
                    for (let i = 0; i < response.length; i++) {
                        var date = new Date(response[i].scandate)
                        var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                        data.push({
                            name: dateString,
                            scans: parseInt(response[i].uniquevisitors),
                        })
                    }
                    this.setState({stats: data})
                })
                
                getMonthlyBaseline((response) =>{
                    console.log(response)
                    var data = []
                    for (let i = 0; i < response.length; i++) {
                        var date = new Date(response[i].scandate)
                        var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                        data.push({
                            name: dateString,
                            scans: parseInt(response[i].uniquevisitors),
                            baseline: parseInt(response[i].baseline),
                        })
                    }
                    this.setState({monthlyBaselineData: data})
                })
            }

            var host = store.getState().host
            if(host !== this.state.host){
                this.setState({host: host})
            }

            var logoToken = store.getState().logoToken
            if(this.state.logoToken !== logoToken){
                this.setState({logoToken: logoToken})
            }

            var rank = store.getState().rank
            if(this.state.rank !== rank){
                document.cookie = `rank=${rank}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                this.setState({rank: rank})
            }

            var location = store.getState().location
            if(this.location !== location){
                console.log("update location")
                document.cookie = `locationid=${location.ID}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                document.cookie = `locationname=${location.name}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
                this.setState({location: location})
            }
        })
        this.setState({deviceToken: store.getState().deviceToken, host: store.getState().host})
        console.log("getting scans")
        getScans((response) =>{
            console.log(response)
            store.dispatch({"type": "scans/update", "payload": response.visitors})
        })
        getCompany((response) =>{
            document.cookie = `baseline=${response.baseline}; expires=Thu, 18 Dec 2100 12:00:00 UTC`;
            this.setState({company: response})
        })
        getLocation((response) =>{
            console.log(response)
            this.setState({location: response})
        })
        getRank((response) =>{
            console.log(response)
            this.setState({rank: response})
            store.dispatch({"type": "leaderboard/updateRank", "payload": response})
        })

        getDaily((response) =>{
            console.log(response)
            var data = []
            for (let i = 0; i < response.length; i++) {
                var date = new Date(response[i].scandate)
                var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                data.push({
                    name: dateString,
                    scans: parseInt(response[i].uniquevisitors),
                })
            }
            this.setState({stats: data})
        })

        getMonthlyBaseline((response) =>{
            console.log(response)
            var data = []
            for (let i = 0; i < response.length; i++) {
                var date = new Date(response[i].scandate)
                var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                data.push({
                    name: dateString,
                    scans: parseInt(response[i].uniquevisitors),
                    baseline: parseInt(response[i].baseline),
                })
            }
            this.setState({monthlyBaselineData: data})
        })
        await new Promise(r => setTimeout(r, 2000));
        if(this.state.location.ID === 0){
            getScans((response) =>{
                console.log(response)
                store.dispatch({"type": "scans/update", "payload": response.visitors})
            })
            getCompany((response) =>{
                this.setState({company: response})
            })
            getLocation((response) =>{
                console.log(response)
                this.setState({location: response})
            })
            getRank((response) =>{
                console.log(response)
                this.setState({rank: response})
                store.dispatch({"type": "leaderboard/updateRank", "payload": response})
            })

            getDaily((response) =>{
                console.log(response)
                var data = []
                for (let i = 0; i < response.length; i++) {
                    var date = new Date(response[i].scandate)
                    var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                    data.push({
                        name: dateString,
                        scans: parseInt(response[i].uniquevisitors),
                    })
                }
                this.setState({stats: data})
            })

            getMonthlyBaseline((response) =>{
                console.log(response)
                var data = []
                for (let i = 0; i < response.length; i++) {
                    var date = new Date(response[i].scandate)
                    var dateString = (date.getMonth() + 1) + "/" + (date.getDate() + 1)
                    data.push({
                        name: dateString,
                        scans: parseInt(response[i].uniquevisitors),
                        baseline: parseInt(response[i].baseline),
                    })
                }
                this.setState({monthlyBaselineData: data})
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    }

    updateOnlineStatus = () => {
        console.log(`is ${navigator.onLine ? "online" : "offline"}`);
        this.setState({ isOnline: navigator.onLine });
    }

    changeStatsVis = async () => {
        var statsBar = document.getElementById("statsBar")
        if(this.state.statsBarOffset === 0){
            await this.setState({statsBarOffset: statsBar.offsetTop})
        }
        const endingPos = 150

        if (!this.state.showStats) {
            await this.setState({showStats: !this.state.showStats})
            statsBar.style.top = this.state.statsBarOffset + "px"
            for (let i = this.state.statsBarOffset; i > endingPos; i--) {
                i -= 30

                if(i <= endingPos){
                    statsBar.style.top = endingPos + "px"
                    break
                }
                statsBar.style.top = i + "px"

                await new Promise(r => setTimeout(r, 0));

            }
            statsBar.style.top = endingPos + "px"
        } else{

            for (let i = endingPos; i < this.state.statsBarOffset; i++) {
                i += 30
                statsBar.style.top = i + "px"
                await new Promise(r => setTimeout(r, 0));
            }
            statsBar.style.top = this.state.statsBarOffset + "px"
            await this.setState({showStats: !this.state.showStats})

        }

    }

    showWifiModule = () => {
        document.getElementById("root").style.display = "none"
        document.getElementById("wifiModule").style.display = "block"
    }

    startupTouchEvents = () => {
        var touchTarget = document.getElementById("statsTouchTarget")

        touchTarget.addEventListener("touchstart", this.handleTouchStart);



    }

    handleTouchStart = () => {
        this.changeStatsVis()
    }

    render() {
        console.log(this.state)
    return (
        <>


            <div className={"html"}>
                <div className={"body"}>
                    <p id={"height"}></p>
                    <header>

                        <div className={"container"}>
                            <img
                                src={`https://${this.state.host}/api/devices/${this.state.deviceToken}/logo?logoToken=${this.state.logoToken}`}
                                alt={"Logo"} style={{maxWidth: "60%", maxHeight: "90px"}}/>
                            <p>
                                <svg style={{height: "18px", marginBottom: "-2px"}} xmlns="http://www.w3.org/2000/svg"
                                     height="24px" viewBox="0 -960 960 960" width="24px"
                                     fill="#011589">
                                    <path
                                        d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 400Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Z"/>
                                </svg>
                                {this.state.location.name !== "undefined" ? this.state.location.name : this.state.deviceToken}
                            </p>
                        </div>
                        <div style={{
                            position: "absolute",
                            top: "15px",
                            right: "15px",
                            display: this.state.isOnline ? "none" : "block"
                        }} onClick={DeviceInterface.openNetworkSettings}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                                 fill="#d6d4d4">
                                <path
                                    d="M790-56 414-434q-47 11-87.5 33T254-346l-84-86q32-32 69-56t79-42l-90-90q-41 21-76.5 46.5T84-516L0-602q32-32 66.5-57.5T140-708l-84-84 56-56 736 736-58 56Zm-310-64q-42 0-71-29.5T380-220q0-42 29-71t71-29q42 0 71 29t29 71q0 41-29 70.5T480-120Zm236-238-29-29-29-29-144-144q81 8 151.5 41T790-432l-74 74Zm160-158q-77-77-178.5-120.5T480-680q-21 0-40.5 1.5T400-674L298-776q44-12 89.5-18t92.5-6q142 0 265 53t215 145l-84 86Z"/>
                            </svg>
                        </div>
                    </header>

                    <section className={"content"}>
                        <div id="scan">
                            <div className={"container"}>
                                <div className={"holder"}>
                                    <h2>Scan Me</h2>
                                    <div className={"qr"}>
                                        <img
                                            src={`https://${this.state.host}/api/devices/${this.state.deviceToken}/${this.state.location.ID}/qr`}
                                            alt="" style={{borderRadius: "5px", height: "250px"}}/>
                                    </div>
                                    <h3 style={{paddingBottom: "0px"}}>Monthly Scans</h3>
                                    <p className="ms" style={{
                                        marginBottom: "0px",
                                        color: this.state.company !== undefined ? (this.state.count < this.state.company.baseline ? "#c25e68" : "") : ""
                                    }}>{this.state.count}</p>
                                    <hr style={{margin: "0px"}}/>
                                    <h3 style={{paddingBottom: "0px", paddingTop: "30px"}}>Rank</h3>
                                    <p className="rank">#{this.state.rank}</p>

                                </div>
                            </div>
                        </div>
                    </section>
                    <div style={{position: "absolute", width:"100%", bottom: "0px"}} id={"statsBar"}>
                        <div className={"stats"} id={"statsTouchTarget"} style={{paddingBottom: "0px", marginLeft: "5%", marginRight: "5%", cursor: "pointer"}}>
                            <h3 style={{paddingBottom: "0px", marginBottom: "9px"}}>
                                {/*<a href="#" data-bs-toggle="collapse" data-bs-target="#statsContent" id="statsTrigger">*/}
                                <a>
                                    <img src={stats} alt={""}/> Stats
                                </a>
                            </h3>
                        </div>

                        <div id="statsContent" className="test" style={{marginLeft: "5%", marginRight: "5%", display: this.state.showStats? "block" : "none", height: "100%"}}>
                            <div className="container" style={{
                                height: "100%",
                                paddingLeft: "0px",
                                overflowY: "scroll",
                                paddingBottom: "100px"
                            }}>
                                <h4>Daily Scans</h4>
                                <LineChart
                                    width={500}
                                    height={300}
                                    data={this.state.stats}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 0,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="name"/>
                                    <YAxis/>
                                    <Tooltip/>
                                    <Legend/>
                                    <Line type="monotone" dataKey="scans" stroke="#82ca9d"/>

                                </LineChart>
                                <p style={{textAlign: "center"}}>Total: {this.state.count}</p>
                                <br/>
                                <hr style={{marginRight: "-20px"}}/>
                                <h4>Monthly Baseline</h4>
                                <LineChart
                                    width={500}
                                    height={300}
                                    data={this.state.monthlyBaselineData}
                                    margin={{
                                        top: 5,
                                        right: 30,
                                        left: 0,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis dataKey="name"/>
                                    <YAxis/>
                                    <Tooltip/>
                                    <Legend/>
                                    <Line type="monotone" dataKey="scans" stroke="#82ca9d"/>
                                    <Line type="monotone" dataKey="baseline" stroke="#ca8287"/>
                                </LineChart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
        ;
    }
}

export default App;
